import React from 'react';
import { Users, Mail } from 'lucide-react';
interface Instructor {
  name: string;
  title: string;
  photo?: string;
  bio: string;
  fullBio?: string;
  initials: string;
}
const instructors: Instructor[] = [{
  name: 'Jon Kichen',
  title: 'Desert Sage Seminars Owner and Instructor',
  photo: 'https://cdn.magicpatterns.com/uploads/3rrVqztecsSvDZ8Krg5Ymg/Fixed_Jon_and_Dana-0136.jpg',
  bio: 'Jon has owned, operated, educated, managed and practiced real estate his entire career. His volunteer time with REALTOR® associations has made him one of a kind... Volunteering through committee ...',
  initials: 'JK'
}, {
  name: 'Tara Rutkowski',
  title: 'Licensed REALTOR®',
  bio: 'Tara Rutkowski is a licensed REALTOR® with a specialty in solar. Along with her GREEN designation with NAR, she has nine years of previous experience working in the solar industry. Her ...',
  initials: 'TR'
}, {
  name: 'Butch Leiber',
  title: 'Owner of Draw A Door Business Coaching',
  bio: 'Butch Leiber is the owner of Draw A Door Business Coaching and is the Designated Broker for Rev Residential Brokerage. Licensed since 2002, Butch has devoted his career to learning the real estate ...',
  initials: 'BL'
}, {
  name: 'Karen Kay',
  title: 'Full-time Real Estate Agent',
  bio: 'Karen Kay has been a full-time Real Estate agent since 1994 servicing the Phoenix area. Karen is an agent with Desert Fairways Realty and is an ADRE Certified CE Instructor at Desert Sage Seminars. ...',
  initials: 'KK'
}, {
  name: 'Tom Noble',
  title: 'Real Estate Professional',
  bio: 'Tom has been a real estate professional for many years and had held many roles. He enjoys working in real estate as well as giving back to the industry.\n\nOwner/Broker, Long Realty Platinum Premier 200...',
  initials: 'TN'
}, {
  name: 'Gary Brown',
  title: 'Real Estate Professional since 1973',
  bio: 'Gary has been in the real estate business since 1973. The first 17 years in commercial real estate specializing in shopping center leasing and development. In 1990 he started his ...',
  initials: 'GB'
}, {
  name: 'James Moore',
  title: 'Real Estate Investor & Educator',
  bio: 'I got started in real estate activities in 2000 when I joined an investment group that bought and flipped properties. In 2004, having a thirst for how a real estate transaction took place I took my ...',
  initials: 'JM'
}, {
  name: 'Mark De Michele',
  title: 'Designated Broker for UBI Business Brokers',
  bio: 'Mark is a 22-year real estate veteran and the designated broker for UBI Business Brokers. As a real estate educator, he offers an energetic and entertaining experience peppered with real estate ...',
  initials: 'MD'
}, {
  name: 'Erika Madsen',
  title: 'Licensed Real Estate Professional',
  bio: 'Erika became licensed in 1997 when she was 24. Her age presented some challenges in the beginning, but she found ways to overcome them and succeed quickly. She has been successful in many capacities ...',
  initials: 'EM'
}];
export function Instructors() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-836">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-837">
        {/* Page Header */}
        <div className="mb-12 text-center" data-id="element-838">
          <div className="flex items-center justify-center mb-4" data-id="element-839">
            <Users className="w-12 h-12 text-[#fcb53d] mr-4" data-id="element-840" />
            <h1 className="text-4xl font-bold text-[#fcb53d]" data-id="element-841">
              Desert Sage Seminars Instructors
            </h1>
          </div>
        </div>

        {/* Instructors Grid - 4 columns on large screens */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-842">
          {instructors.map(instructor => <div key={instructor.name} className="bg-white rounded-lg border-2 border-gray-200 overflow-hidden hover:border-brand-purple-300 transition-colors" data-id="element-843">
              {/* Instructor Photo - Square aspect ratio */}
              <div className="aspect-square bg-gray-100 overflow-hidden" data-id="element-844">
                {instructor.photo ? <img src={instructor.photo} alt={instructor.name} className="w-full h-full object-cover" data-id="element-845" /> : <div className="w-full h-full bg-brand-purple-600 flex items-center justify-center" data-id="element-846">
                    <span className="text-5xl font-bold text-white" data-id="element-847">
                      {instructor.initials}
                    </span>
                  </div>}
              </div>

              {/* Instructor Info */}
              <div className="p-4" data-id="element-848">
                <h3 className="text-lg font-bold text-brand-purple-600 mb-1" data-id="element-849">
                  {instructor.name}
                </h3>
                {instructor.title && <p className="text-xs font-semibold text-gray-700 mb-2" data-id="element-850">
                    {instructor.title}
                  </p>}
                <p className="text-xs text-gray-700 leading-relaxed mb-3 whitespace-pre-line line-clamp-3" data-id="element-851">
                  {instructor.bio}
                </p>

                {/* Action Buttons */}
                <div className="flex flex-col gap-2" data-id="element-852">
                  <button className="w-full px-3 py-2 bg-brand-purple-600 text-white font-semibold rounded-md hover:bg-brand-purple-700 transition-colors text-xs flex items-center justify-center" data-id="element-853">
                    <Mail className="w-3 h-3 mr-1" data-id="element-854" />
                    Contact Me
                  </button>
                  <button className="w-full px-3 py-2 text-brand-purple-600 font-semibold rounded-md border-2 border-brand-purple-600 hover:bg-brand-purple-50 transition-colors text-xs" data-id="element-855">
                    Read More
                  </button>
                </div>
              </div>
            </div>)}
        </div>

        {/* Call to Action */}
        <div className="mt-16 bg-brand-purple-50 rounded-lg p-8 text-center border border-brand-purple-100" data-id="element-856">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-857">
            Interested in Teaching with Us?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-858">
            Desert Sage Seminars is always looking for qualified, experienced
            real estate professionals to join our team of instructors.
          </p>
          <a href="/Contact" className="inline-flex items-center px-8 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors" data-id="element-859">
            <Mail className="w-5 h-5 mr-2" data-id="element-860" />
            Get in Touch
          </a>
        </div>
      </div>
    </div>;
}